export default "__VITE_ASSET__f53b051a__"